import ClientSnapshot from "./ClientSnapshot";

export default ClientSnapshot;